import { render, staticRenderFns } from "./menuOptions.vue?vue&type=template&id=008916dc&"
import script from "./menuOptions.vue?vue&type=script&lang=js&"
export * from "./menuOptions.vue?vue&type=script&lang=js&"
import style0 from "./menuOptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports